import requestFrame from "./request-frame.js";

// `maxFps` (optional) caps how often the simulation steps, independent of the
// rAF cadence. Omitted = step every frame (real matches, unchanged). Decorative
// previews pass a low value (e.g. 30) to halve sim + render cost; the ~5ms
// tolerance makes it land on the intended frame at a 60Hz rAF instead of slipping
// to the next one.
export default function LocalGameHandler({ game, onGameOver, maxFps = 0 }) {

    var minInterval = maxFps ? (1000 / maxFps) - 5 : 0;

    var localGameState = {
        paused: false,
        previousUpdateTime: 0
    };

    function start() {
        localGameState.previousUpdateTime = Date.now();
        game.start();
        requestFrame(update);
    }

    function update() {
        if (game.isActive()) {
            var currentTime = Date.now();
            if (!localGameState.paused) {
                var elapsed = currentTime - localGameState.previousUpdateTime;
                // Throttled: skip this frame's step until enough time has passed,
                // keeping previousUpdateTime so the elapsed time accumulates.
                if (elapsed >= minInterval) {
                    game.update(elapsed / 1000);
                    localGameState.previousUpdateTime = currentTime;
                }
            } else {
                // Paused: hold the clock so resume doesn't apply a giant dt.
                localGameState.previousUpdateTime = currentTime;
            }

            if (game.isActive()) {
                requestFrame(update);
            } else {
                if (onGameOver) {
                    onGameOver();
                }
            }
        }
    }

    function pause() {
        localGameState.paused = true;
    }

    function resume() {
        localGameState.paused = false;
        localGameState.previousUpdateTime = Date.now();
    }

    function isPaused() {
        return localGameState.paused;
    }

    function stop() {
        game.stop();
    }

    return {
        start,
        pause,
        resume,
        stop,
        isActive: game.isActive,
        isPaused,
        gameState: game.gameState,
        game // exposed so the game-over screen can keep running it for the victory lap
    };
};
